var flatten = {};
export {
  flatten as __exports
};
//# sourceMappingURL=flatten.js.map
